import React, { Component } from "react";
import classnames from "classnames";
import { Image, Form } from "react-bootstrap";
import Modal from "react-modal";
import { InputBoxComponent } from "../../reusableComponents/inputReusableComponent/InputBoxComponent";
// import isEmpty from "../../../store/validation/is-Empty";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import { change_password_vendor } from "../../../store/actions/ChangePasswordAction/changePasswordAction";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    position: "relative",
    padding: "0px",
  },
};

export class VendorChangePassword extends Component {
  constructor(props) {
    super();
    this.state = {
      open: false,
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      passwordIcon: true,
      slashEyeIcon: false,
      errors: {},
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  onOpenModal = (e) => {
    this.setState({ open: true });
  };

  onCloseModal = (e) => {
    this.setState({ open: false });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
    });
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      case "password":
        errors.confirmNewPassword =
          value.length < 6 ? "Password must contain atleast 6 characters" : "";
        break;
      case "confirmNewPassword":
        errors.confirmNewPassword =
          value.length < 6
            ? "Confirm password must contain atleast 6 characters"
            : "";
        break;
      default:
        break;
    }

    this.setState({ errors, [name]: value });
    this.props.clear_all_errors();
  };

  onPasswordChange = (e) => {
    this.setState({
      view: !this.state.view,
      passwordIcon: false,
      slashEyeIcon: true,
    });
  };

  onPasswordHide = (e) => {
    this.setState({
      view: !this.state.view,
      passwordIcon: true,
      slashEyeIcon: false,
    });
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const formData = {
      oldPassword: this.state.currentPassword,
      newPassword: this.state.newPassword,
    };
    this.props.change_password_vendor(formData, token, this.onCloseModal);
  };

  render() {
    const {
      //   currentPassword,
      newPassword,
      confirmNewPassword,
      passwordIcon,
      slashEyeIcon,
      errors,
    } = this.state;
    return (
      <React.Fragment>
        <p
          className="login-bottom-text text-danger"
          style={{ fontWeight: "500", cursor: "pointer" }}
          onClick={this.onOpenModal}
        >
          Change Password
        </p>
        <Modal
          isOpen={this.state.open}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.onCloseModal}
          style={customStyles}
          className="reservation-vendor-model-popup"
          contentLabel="Example Modal"
          ariaHideApp={false}
        >
          <div>
            <div className="reservation-vendor-model-popup-header">
              <Image
                src={require("../../../assets/images/ActionImages/backbuttonnew.png")}
                alt="back button"
                title="Back Button"
                fluid
                onClick={this.onCloseModal}
              />
              <h4>Change Password</h4>
            </div>
            <hr />
            <div className="pl-3 pr-3">
              <Form noValidate onSubmit={this.onHandleSubmit}>
                <InputBoxComponent
                  displayLabel={true}
                  passwordIcon={passwordIcon}
                  slashEyeIcon={slashEyeIcon}
                  controlId="currentPassword"
                  labelText="Enter Current Password"
                  inputType={!this.state.view ? "password" : "text"}
                  placeHolder="*******"
                  name="currentPassword"
                  onChange={this.handleChange}
                  onFocusOut={this.onFocusOut}
                  value={this.state.currentPassword}
                  required="required"
                  passwordShow={this.onPasswordChange}
                  passwordHide={this.onPasswordHide}
                  showBottom={true}
                  error={
                    (this.state.currentPassword > 0 &&
                      errors.currentPassword) ||
                    errors.currentPassword ||
                    errors.code === 403
                      ? "Current Password does not match"
                      : null
                  }
                  inputClassName={classnames("input-component-inputfield", {
                    invalid: errors.password,
                  })}
                />
                <InputBoxComponent
                  displayLabel={true}
                  passwordIcon={passwordIcon}
                  slashEyeIcon={slashEyeIcon}
                  controlId="newPassword"
                  labelText="New Password"
                  inputType={!this.state.view ? "password" : "text"}
                  placeHolder="*******"
                  name="newPassword"
                  onChange={this.handleChange}
                  onFocusOut={this.onFocusOut}
                  value={this.state.newPassword}
                  required="required"
                  passwordShow={this.onPasswordChange}
                  passwordHide={this.onPasswordHide}
                  showBottom={true}
                  error={
                    (this.state.newPassword > 0 && errors.newPassword) ||
                    errors.newPassword
                  }
                  inputClassName={classnames("input-component-inputfield", {
                    invalid: errors.newPassword,
                  })}
                />
                <InputBoxComponent
                  displayLabel={true}
                  controlId="confirmNewPassword"
                  labelText="Confirm New Password"
                  inputType={!this.state.view ? "password" : "text"}
                  placeHolder="*******"
                  name="confirmNewPassword"
                  onChange={this.handleChange}
                  onFocusOut={this.onFocusOut}
                  value={this.state.confirmNewPassword}
                  required="required"
                  showBottom={true}
                  error={
                    this.state.confirmNewPassword.length === 0
                      ? errors.confirmNewPassword
                      : "Password doesn't match, please Re-Enter" &&
                        this.state.newPassword !== this.state.confirmNewPassword
                      ? "Password doesn't match, please Re-Enter"
                      : ""
                  }
                  inputClassName={classnames("input-component-inputfield", {
                    invalid: errors.confirmNewPassword,
                  })}
                />
                <div className="d-flex justify-content-between mt-4">
                  <button
                    type="button"
                    className="change-password-button change-password-button-back"
                    onClick={this.onCloseModal}
                  >
                    Back
                  </button>
                  <button
                    type={
                      newPassword.length < 6 || confirmNewPassword.length < 6
                        ? "button"
                        : "submit"
                    }
                    disabled={
                      newPassword.length < 6 || confirmNewPassword.length < 6
                        ? true
                        : false
                    }
                    className={
                      newPassword.length < 6 || confirmNewPassword.length < 6
                        ? "change-password-button change-password-button-back"
                        : "change-password-button change-password-button-save"
                    }
                  >
                    Save
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

VendorChangePassword.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  change_password_vendor,
})(withRouter(VendorChangePassword));
